import React,{useEffect,useState}from'react';import{Navigate,useLocation}from'react-router-dom';import{useSelector}from'react-redux';import{LoadingOutlined}from'@ant-design/icons';import{Flex,Spin}from'antd';import{isAuthEnabled,getDebugToken}from"../services/utils/authUtils";import{Fragment as _Fragment,jsx as _jsx}from"react/jsx-runtime";export const ProtectedRoute=_ref=>{let{children}=_ref;const location=useLocation();const{user,loading}=useSelector(state=>state.auth);const[checkingAuth,setCheckingAuth]=useState(true);const[needsRedirect,setNeedsRedirect]=useState(false);useEffect(()=>{// Function to check authentication status
const checkAuthentication=()=>{// Check if authentication is disabled in config
if(!isAuthEnabled()){console.log('Authentication is disabled - bypassing auth check');// Set debug token if auth is disabled
const debugToken=getDebugToken();if(debugToken){localStorage.setItem('token',debugToken);console.log('Using debug token for authentication');}setCheckingAuth(false);return;}// Auth is enabled - check if we have a valid token
const token=localStorage.getItem('token');// No token - immediate redirect needed
if(!token){console.log('No authentication token found - redirect needed');setNeedsRedirect(true);setCheckingAuth(false);return;}// Has token - check if it's valid
try{// Validate token expiration
const tokenPayload=JSON.parse(atob(token.split('.')[1]));const expirationTime=tokenPayload.exp*1000;// Convert to milliseconds
if(Date.now()>=expirationTime){// Token expired - redirect needed
console.log('Token is expired - redirect needed');localStorage.removeItem('token');setNeedsRedirect(true);}}catch(error){// Invalid token format - redirect needed
console.error('Error checking token:',error);localStorage.removeItem('token');setNeedsRedirect(true);}// Done checking
setCheckingAuth(false);};// Run the auth check
checkAuthentication();},[]);// Empty dependency array to run only once on mount
// If auth is disabled, always allow access
if(!isAuthEnabled()){console.log('Authentication is disabled - allowing access to protected route');return/*#__PURE__*/_jsx(_Fragment,{children:children});}// Redirect to login if needed (only when auth is enabled)
if(needsRedirect||!user){// Save the current location for redirect after login
console.log('Redirecting to authentication page from:',location.pathname);localStorage.setItem('redirectPath',location.pathname);return/*#__PURE__*/_jsx(Navigate,{to:"/auth/signin",state:{from:location},replace:true});}// Still checking auth state
if(loading||checkingAuth){return/*#__PURE__*/_jsx(Flex,{align:"center",justify:"center",style:{height:'100vh'},children:/*#__PURE__*/_jsx(Spin,{indicator:/*#__PURE__*/_jsx(LoadingOutlined,{style:{fontSize:24},spin:true})})});}// User is authenticated
return/*#__PURE__*/_jsx(_Fragment,{children:children});};export default ProtectedRoute;// import React, { useEffect, useState } from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { RootState } from '../../redux/store';
// import { PATH_AUTH } from '../../constants';
// import { LoadingOutlined } from '@ant-design/icons';
// import { Flex, Spin } from 'antd';
// interface ProtectedRouteProps {
//   children: React.ReactNode;
// }
// const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
//   const location = useLocation();
//   const { user, loading } = useSelector((state: RootState) => state.auth);
//   const [checkingAuth, setCheckingAuth] = useState(false); // Set to false to skip checking
//   useEffect(() => {
//     console.log('DEBUG MODE: Authentication check bypassed');
//     // DEBUG MODE: Set mock authentication data
//     if (!localStorage.getItem('token')) {
//       localStorage.setItem('token', 'debug-token.with.signature');
//     }
//     if (!localStorage.getItem('user_id')) {
//       localStorage.setItem('user_id', 'test-user-id');
//     }
//     // Always set checking to false to proceed
//     setCheckingAuth(false);
//   }, []);
//   // Still checking auth state
//   if (loading || checkingAuth) {
//     return (
//       <Flex align="center" justify="center" style={{ height: '100vh' }}>
//         <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
//       </Flex>
//     );
//   }
//   // DEBUG MODE: Always allow access to protected routes
//   console.log('DEBUG MODE: Bypassing authentication check, allowing access to protected route');
//   // Always render children without checking authentication
//   return <>{children}</>;
// };
// export default ProtectedRoute;